// apps/web/src/services/feedService.js
import { apiRequest } from './api';

export const FeedService = {
    async getFeed(limit = 30, offset = 0) {
        return apiRequest(`/feed?limit=${limit}&offset=${offset}`);
    },
    /**
     * Home feed (docs/home-feed.md).
     * @param {'for_you'|'following'} tab
     * @param {string|null} cursor  nextCursor from the previous page
     * Returns: { tab, cards, nextCursor, hasMore, meta }
     */
    async getHome(tab = 'for_you', cursor = null) {
        const params = new URLSearchParams({ tab });
        if (cursor) params.set('cursor', cursor);
        return apiRequest(`/feed/home?${params.toString()}`);
    },
    async getMomentum() {
        return apiRequest('/feed/momentum');
    },
    async getTrending() {
        return apiRequest('/feed/trending', { authenticated: false });
    },
    /** Returns seeded titles from the user's onboarding selections */
    async getOnboardingSuggestions() {
        return apiRequest('/onboarding/suggestions');
    },
    // reaction: 'impressive' | 'legendary' | 'trying' | 'watchlisted' | null
    async react(eventId, reaction) {
        return apiRequest(`/feed/${encodeURIComponent(eventId)}/react`, {
            method: 'POST',
            body: { reaction },
        });
    },
};